export const common = {
  // Navigation
  aboutUs: 'Chi Siamo',
  services: 'Servizi',
  brands: 'Marchi',
  marketInsights: 'Approfondimenti di Mercato',
  contact: 'Contatti',
  
  // Hero Section
  heroTitle: 'Collegare la Moda Europea con i Mercati Cinesi',
  heroSubtitle: 'XINRUNMODA collega i marchi europei con i canali di vendita al dettaglio cinesi',
  getStarted: 'Inizia',
  learnMore: 'Scopri di Più',
  
  // About Section
  whoWeAre: 'Chi Siamo',
  aboutDescription1: 'Sfruttando il ruolo di Hong Kong come hub commerciale internazionale, XINRUNMODA collega i marchi europei e i canali di vendita cinesi. Curiamo la moda europea premium e forniamo servizi affidabili di supply chain end-to-end.',
  aboutDescription2: 'La nostra posizione strategica a Hong Kong ci posiziona perfettamente per comprendere sia l\'eccellenza della moda europea che le dinamiche del mercato cinese, consentendo relazioni commerciali interculturali senza soluzione di continuità.',
  partnerBrands: 'Marchi Partner',
  retailPartners: 'Partner di Vendita',
  
  // Services Section
  ourServices: 'I Nostri Servizi',
  servicesDescription: 'Dall\'approvvigionamento dei marchi alla penetrazione del mercato, forniamo soluzioni commerciali complete per la moda',
  brandSourcing: 'Sourcing Marchi',
  brandSourcingDesc: 'Selezione di marchi di moda europea premium per offerte di mercato uniche',
  supplyChain: 'Gestione Supply Chain',
  supplyChainDesc: 'Soluzioni logistiche end-to-end che garantiscono consegne tempestive ed efficienti',
  marketEntry: 'Ingresso nel Mercato',
  marketEntryDesc: 'Facilitazione dell\'ingresso dei marchi europei nei mercati cinesi con supporto localizzato',
  retailNetwork: 'Rete di Vendita',
  retailNetworkDesc: 'Ampia rete di partner di vendita nelle principali città cinesi',
  
  // Brands Section
  featuredBrands: 'Marchi in Evidenza',
  brandsDescription: 'Collaboriamo con i migliori marchi di moda europei per portare le ultime tendenze ai consumatori cinesi',
  
  // Market Insights Section
  marketInsightsTitle: 'Analisi di Mercato',
  marketInsightsDescription: 'Comprensione approfondita delle tendenze del mercato della moda cinese e delle preferenze dei consumatori',
  
  // Contact Section
  contactTitle: 'Contattaci',
  contactDescription: 'Pronto per iniziare il tuo viaggio nel commercio della moda? Discutiamo di come possiamo aiutare il tuo marchio ad avere successo nel mercato cinese.',
  getInTouch: 'Mettiti in Contatto',
  ourLocation: 'La Nostra Sede',
  emailUs: 'Inviaci una Email',
  
  // Footer
  footerDescription: 'XINRUNMODA - Azienda professionale di commercio della moda che collega i marchi europei ai mercati cinesi',
  quickLinks: 'Link Rapidi',
  contactInfo: 'Informazioni di Contatto',
  followUs: 'Seguici',
  allRightsReserved: 'Tutti i diritti riservati'
};